/******************************************
 *  Author : Suraj Sharma
 *  Created On : Mon Jan 04 2021
 *  File : index.jsx
 *******************************************/
import FooterNavigator from './FooterNavigator';

export default FooterNavigator;